import { apiAService, apiService } from "../apiService";
import urlConfig from "../../../config/domain";
import {
  IChangePassword,
  IMergeRequest,
} from "../../types/components/login/loginTypes";
import { ILeadFormFields } from "../../login/forms/leadForm";
import loginURLConfig from "../../../config/login/loginURLConfig";

export const AGetSecurityImage = (
  callback: CallableFunction,
  usrId: string
) => {
  apiService(
    {
      url: loginURLConfig.accounts + usrId + "/image?ff=W",
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      source: sessionStorage.getItem("source") || undefined,
      sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
    },
    callback
  );
};

export const GetAsyncSecurityImage = async (usrId: string) => {
  return await apiAService({
    url: loginURLConfig.accounts + usrId + "/image?ff=W",
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
    sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
  });
};

export const A2faQuestions = (
  callback: CallableFunction,
  usrId: string,
  accTyp: string,
  pwd: string
) => {
  apiService(
    {
      url: loginURLConfig.accounts + usrId + "/2faquestions",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      source: sessionStorage.getItem("source") || undefined,
      sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
      body: { pwd, accTyp, ff: "W", ip: "" },
    },
    callback
  );
};

export const AVerifyAnswers = (
  callback: CallableFunction,
  usrId: string,
  accTyp: string,
  yob: string
) => {
  apiService(
    {
      url: loginURLConfig.accounts + usrId + "/verifyanswers/v2",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      source: sessionStorage.getItem("source") || undefined,
      sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
      body: {
        ansLst: [{ idx: "1", ans: yob }],
        accTyp,
        appData: { vendor: sessionStorage.getItem("source") || undefined },
      },
    },
    callback
  );
};

export const AGetConsents = (
  callback: CallableFunction,
  usrId: string,
  consents: Array<string>
) => {
  console.log({
    url: loginURLConfig.consent + "content/" + usrId,
    method: "POST",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    body: { consents },
  });

  apiService(
    {
      url: loginURLConfig.consent + "content/" + usrId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { consents },
    },
    callback
  );
};

export const ASaveMulConsents = (
  callback: CallableFunction,
  usrId: string,
  consents: Array<any>
) => {
  apiService(
    {
      url: loginURLConfig.consent + "save/multiple/" + usrId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { ip: "", consents },
    },
    callback
  );
};

export const AResetLoginId = (
  callback: CallableFunction,
  usrId: string,
  nwUid: string
) => {
  apiService(
    {
      url: loginURLConfig.accounts + usrId + "/changeuserid",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { nwUid, cnNwUid: nwUid },
    },
    callback
  );
};

export const AResetPassword = (
  callback: CallableFunction,
  usrId: string,
  body: IChangePassword
) => {
  apiService(
    {
      url: loginURLConfig.accounts + usrId + "/changepassword/v2",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const ASaveTncConsent = (
  callback: CallableFunction,
  usrId: string,
  save: boolean
) => {
  apiService(
    {
      url:
        loginURLConfig.consent +
        "vendor/" +
        usrId +
        "?save=" +
        (save ? "true" : "false"),
      method: "PUT",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: {},
    },
    callback
  );
};

export const AForgotLoginId = (callback: CallableFunction, body: any) => {
  apiService(
    {
      url: loginURLConfig.accounts + "forgotuserid",
      method: "PUT",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AForgotPassword = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/resetpassword",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AUnblockAccount = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/unblockuser",
      method: "PUT",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AForgotYob = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/yob",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AMergeRequest = (
  callback: CallableFunction,
  body: IMergeRequest
) => {
  apiService(
    {
      url: loginURLConfig.merge + "request",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AMergeRemindLater = (callback: CallableFunction) => {
  apiService(
    {
      url: loginURLConfig.merge + "remindmelater",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: {},
    },
    callback
  );
};

export const AMergeActivateAccount = (
  callback: CallableFunction,
  uid: string,
  accTyp: string
) => {
  apiService(
    {
      url: loginURLConfig.merge + "activateaccount",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { uid, accTyp },
    },
    callback
  );
};

export const AMergeEnableAccount = (
  callback: CallableFunction,
  uid: string,
  accTyp: string
) => {
  apiService(
    {
      url: loginURLConfig.merge + "onlineenable",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { uid, accTyp },
    },
    callback
  );
};

export const ARmRateSubmit = (
  callback: CallableFunction,
  userId: string,
  body: any
) => {
  apiService(
    {
      url: loginURLConfig.raterm + "submit/" + userId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AGetCities = (callback: CallableFunction, srchstr: string) => {
  apiService(
    {
      url: loginURLConfig.commAccOpen + "location?srchstr=" + srchstr,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};

export const ACommAccOpenPre = (
  callback: CallableFunction,
  body: ILeadFormFields
) => {
  apiService(
    {
      url: loginURLConfig.commAccOpen + "prelogin",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const ACommAccOpenPost = (
  callback: CallableFunction,
  userId: string
) => {
  apiService(
    {
      url: loginURLConfig.commAccOpen + "postlogin/" + userId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: {},
    },
    callback
  );
};

export const AGetJwtTokenForNestRrader = (
  callback: CallableFunction,
  body: any
) => {
  apiService(
    {
      url: loginURLConfig.jwttokenfornesttrader,
      method: "POST",
      body,
    },
    callback
  );
};

export const AImpersonateUser = (callback: CallableFunction) => {
  apiService(
    {
      url: loginURLConfig.cAccount + "ImpersonateUser",
      method: "POST",
      authType: "bearer",
    },
    callback
  );
};

export const ImpersonateUser = () => {
  apiAService(
    {
      url: loginURLConfig.cAccount + "ImpersonateUser",
      method: "POST",
      authType: "bearer",
    },
  );
};
export const ARegisterDevice = (callback: CallableFunction, body: any) => {
  apiService(
    {
      url: loginURLConfig.clevertapRegister,
      method: "POST",
      authType: "bearer",
      body,
    },
    callback
  );
};

export const ACheckTokenValidity = (callback: CallableFunction) => {
  apiService(
    {
      url: loginURLConfig.cAccount + "CheckTokenValidity",
      method: "GET",
      authType: "bearer",
    },
    callback
  );
};

export const AGetLoginResponse = (callback: CallableFunction) => {
  apiService(
    {
      url: loginURLConfig.cAccount + "GetLoginResponse",
      method: "GET",
      authType: "bearer",
    },
    callback
  );
};

export const ARetrieveQueryData = (
  callback: CallableFunction,
  token: string
) => {
  apiService(
    {
      url: loginURLConfig.adhoc + "retrieve/data",
      method: "POST",
      appidkey: urlConfig.appidkey,
      body: { token },
    },
    callback
  );
};

export const ASaveQueryData = (callback: CallableFunction, value: any) => {
  apiService(
    {
      url: loginURLConfig.adhoc + "save/data",
      method: "POST",
      appidkey: urlConfig.appidkey,
      body: { value: JSON.stringify(value) },
    },
    callback
  );
};
